module.exports = __webpack_public_path__ + "static/media/error.1c11ac42.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/common/Resources/Sounds/error.mp3
// module id = 3212
// module chunks = 0